import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { CompanyProfile } from '../Vendors/Profile';
import { getCompanyDetail } from '../../services/companyDetail';
import { Company } from '../../interfaces/users.interface';
import { useAppSelector } from '../../app/hooks';
import { USER_TYPES } from '../../services/user';

export default function CompanyDetail() {
  const params = useParams();
  const companyId:string = params.companyId!;
  const { user } = useAppSelector(state => state.user);
  const [company, setCompany] = useState<Company | null>(null);

  useEffect(() => {
    if (!user || !companyId) return;
    if (user.type === USER_TYPES.ASSESSOR && (user.companies[0].id as number) !== parseInt(companyId)) return;
    if (user.type === USER_TYPES.VENDOR_ADMIN && (user.companies[0].id as number) !== parseInt(companyId)) return;
    // Seed the profile from the lightweight /company-detail/ endpoint. The profile
    // renders its header/sections from /company-detail/ (v2) or self-fetches the full
    // company from the id (v1); the heavy /companies/{id}/ load is no longer issued here.
    getCompanyDetail(companyId).then((detail) => {
      setCompany(detail as unknown as Company);
    });
  }, [companyId, user]);

  return (
    <>
      {company && <CompanyProfile company={company} />}
    </>
  );
}
